module.exports = __webpack_public_path__ + "img/invite-box-bg.79ac60c8.png";